const defaultEmployeeTeams = [
    'Event Planning',
    'Commercial Training',
    'Governance',
    'Manager',
    'Supervisor',
    'Personnel',
    'Make Ready',
    'Fleet',
    'Finance'
]

export default defaultEmployeeTeams